<form [formGroup]="form">
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label" nzRequired>
            {{resolveKey("Name")| translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="meunuNametpl">
            <input nz-input formControlName="name" [maxlength]="20">
            <!-- <mm-i18n-text formControlName="name" required></mm-i18n-text> -->
            <ng-template #meunuNametpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{'Validate.Required' | translate}}</ng-container>
                <ng-container *ngIf="control.hasError('maxLength')">{{'Validate.MaxLength20' | translate}}</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{resolveKey("Type") | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <nz-select formControlName="type">
                <nz-option *ngIf="showFolderOption" [nzValue]="'Folder'" [nzLabel]="resolveKey('Folder') | translate"></nz-option>
                <nz-option [nzValue]="'Link'" [nzLabel]="resolveKey('Link') | translate"></nz-option>
                <nz-option [nzValue]="'ExternalLink'" [nzLabel]="resolveKey('ExternalLink') | translate"></nz-option>
                <!-- <nz-option [nzValue]="'RedirectLink'" [nzLabel]="resolveKey('RedirectLink') | translate"></nz-option> -->
                <!-- <nz-option [nzValue]="'Dynamic'" [nzLabel]="resolveKey('Dynamic') | translate"></nz-option> -->
            </nz-select>
        </nz-form-control>

    </nz-form-item>

    <nz-form-item *ngIf="showUrlInput$ | async">
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{resolveKey("ModuleUrl") | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="urltpl">
            <nz-select formControlName="moduleUrl" (ngModelChange)="urlChanged($event)">
                <nz-option *ngFor="let item of systemMenu" [nzValue]="item.url" [nzLabel]="item.name | localize" [nzDisabled]="item.disabled"></nz-option>
            </nz-select>
             <!-- <mm-i18n-text formControlName="name" required></mm-i18n-text> -->
             <ng-template #urltpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{'Validate.Required' | translate}}</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>

    <!-- <nz-form-item *ngIf="showMenuApiUrlInput$ | async">
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{resolveKey("MenuApiUrl") | translate}}2
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="urltpl">
            <input nz-input formControlName="url">
            <ng-template #urltpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{'Validate.Required' | translate}}</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item> -->

    <nz-form-item *ngIf="showHttpUrlInput$ | async">
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{resolveKey("HttpUrl") | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="urltpl">
            <input nz-input formControlName="httpUrl">
            <ng-template #urltpl let-control>
                <ng-container *ngIf="control.hasError('required')">{{'Validate.Required' | translate}}</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{resolveKey("Icon") | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <nz-select formControlName="icon" nzAllowClear [nzCustomTemplate]="defaultTemplate">
                <nz-option *ngFor="let icon of icons" nzCustomContent nzLabel="Windows" [nzValue]="icon">
                    <div class="icon-btn-bg"><i nz-icon [nzType]="icon"></i></div>
                </nz-option>
            </nz-select>
            <ng-template #defaultTemplate let-selected>
                <div class="icon-btn-bg">
                    <i nz-icon [nzType]="selected.nzValue"></i>
                </div>
            </ng-template>
        </nz-form-control>

    </nz-form-item>

    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{resolveKey("Description") | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <textarea rows="4" nz-input formControlName="description"></textarea>
            <!-- <mm-i18n-text formControlName="description"></mm-i18n-text> -->
        </nz-form-control>
    </nz-form-item>
</form>
<div *nzModalFooter>
    <!--<button (click)="save()" nz-button>{{resolveKey('OK') | translate}}</button>
    <button (click)="cancel()" nz-button>{{resolveKey('Cancel') | translate}}</button>-->
    <button (click)="cancel()" type="button" nz-button>{{'Common.Cancel' | translate}}</button>
    <button (click)="save()" type="submit" nz-button nzType="primary">{{'Common.Save' | translate}}</button>
</div>